import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { itemHoverColor } from 'utils/colors';
import classNames from 'classnames';

const useStyles = makeStyles(() =>
  createStyles({
    flex: {
      display: 'flex',
      alignItems: 'center',
      height: '100%'
    },
    clickable: {
      '&:hover': {
        backgroundColor: itemHoverColor,
        cursor: 'pointer'
      }
    },
    content: {
      flexGrow: 1
    }
  })
);

interface LinkCardProps {
  children: any;
  clickable?: boolean;
  title?: any;
  icon?: any;
  onClick?: any;
}

const LinkCard = ({
  children,
  clickable = true,
  title = null,
  icon = null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {}
}: LinkCardProps) => {
  const classes = useStyles();

  const cardClasses = clickable
    ? classNames(classes.flex, classes.clickable)
    : classes.flex;

  return (
    <div className={cardClasses} style={{ padding: '1rem' }} onClick={onClick}>
      {icon}
      <div
        className={classes.content}
        style={icon ? { marginLeft: '2rem' } : {}}
      >
        {title && <div className="dashboardLink">{title}</div>}
        {children}
      </div>
    </div>
  );
};

export default LinkCard;
